import React , {useState , useEffect , useRef} from "react";
import { ApiService } from "../../component/Services/apiservices";
import {  useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

let apiServices = new ApiService()
function AdminHome(){
const didMountRef = useRef(true)
const [userName , setUserName] = useState("")
const [userPassword , setUserPassword] = useState("")
const Navigate = useNavigate()
    useEffect(() => {

        if (didMountRef.current) {
            if(JSON.parse(localStorage.getItem('USER_DATA')) !== null){
                Navigate("/csadmin/dashboard")
              }
              else{
                
              }
        }
        didMountRef.current = false;
    })

    const loginCheck =()=>{
        if(userName == ""){
            toast.error("Email is Required")
            return false
        }
        if(userPassword == ""){
            toast.error("Password is required")
            return false
        }
       
        const dataString = {
            username :  userName , 
            password : userPassword

        }
  apiServices.getadminloginPostRequest(dataString).then(res=>{
    if(res.data.status == "success"){
       localStorage.setItem('USER_DATA',JSON.stringify(res.data.data))
        Navigate("/csadmin/dashboard")
    }
    else if(res.data.status == "error"){
     toast.error(res.data.message)
    }

  }).catch((error)=>{})
    }
    return(
        <>
  <ToastContainer/>
   

   <div class="auth-page-wrapper pt-5">
 
        <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
            <div class="bg-overlay"></div>

          <div className="shape">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
      >
        <path
          d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"
          fill="#fff" // You can change this color
        ></path>
      </svg>
    </div>
        </div>

        
        <div class="auth-page-content">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center mt-sm-5 mb-4 text-white-50">
                            <div>
                                <a href="index.html" class="d-inline-block auth-logo">
                                    <img src="/img/logo.png" alt="" height="20"/>
                                </a>
                            </div>
                           
                        </div>
                    </div>
                </div>
          

                <div class="row justify-content-center">
                    <div class="col-md-8 col-lg-6 col-xl-5">
                        <div class="card mt-4">

                            <div class="card-body p-4">
                                <div class="text-center mt-2">
                                  <h5 className="text-primary">Welcome Back !</h5>
                                            <p className="text-muted">Sign in to continue to Proptrail.</p>
                                </div>
                                <div class="p-2 mt-4">
                                  

                                        <div class="mb-3">
                                            <label for="username" class="form-label">Username</label>
                                             <input type="text" className="form-control" id="username" onChange={(e)=>setUserName(e.target.value)} placeholder="Enter username"/>
                                        </div>

                                        <div class="mb-3">
                                            
                                            <label class="form-label" for="password-input">Password</label>
                                            <div class="position-relative auth-pass-inputgroup mb-3">
                                                 <input type="password" className="form-control" id="password" onChange={(e)=>setUserPassword(e.target.value)} placeholder="Enter password"/>
                                               
                                            </div>
                                        </div>

                                      

                                        <div class="mt-4">
                                            <button class="btn btn-success w-100" type="submit" onClick={loginCheck}>Sign In</button>
                                        </div>

                                </div>
                            </div>
                          
                        </div>
                    
                    </div>
                </div>
              
            </div>
           
        </div>
        
        <footer class="footer">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center">
                           

                             <p className="mb-0 text-muted">&copy;
                                <script>document.write(new Date().getFullYear())</script> Proptrail. Crafted with <i className="mdi mdi-heart text-danger"></i> by Codexo Software
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
       
    </div>
        </>
    )
}
export default AdminHome